import type { ID } from '@octopus-do/octopus-project-core'
import type { WorkspaceItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { FolderRenderer } from './components'

interface Props {
  folders: WorkspaceItem[]
  workspaceId: ID
  showFolderAccess: boolean
  lastIdx: number
  activeFolder: ID | null
  renamingFolder: ID | null
  onHideInput: () => void
  onClick: (keys: string[]) => void
}

export const CustomFolders: React.FC<Props> = ({
  folders,
  workspaceId,
  lastIdx,
  activeFolder,
  renamingFolder,
  onHideInput,
  onClick,
  showFolderAccess,
}) => {
  return (
    <>
      {folders.map((folder, i) => (
        <FolderRenderer
          showFolderAccess={showFolderAccess}
          key={folder.id}
          folder={folder}
          i={i}
          renamingFolder={renamingFolder}
          workspaceId={workspaceId}
          lastIdx={lastIdx}
          activeFolder={activeFolder}
          onHideInput={onHideInput}
          onClick={onClick}
        />
      ))}
    </>
  )
}
